import { FC, useEffect, useState } from 'react';
import { InformationIcon } from '../../assets/images/shopping';
import Arrows from '../../assets/images/shopping/arrows';
import { IProductList, ORDER_STATUS } from '../../types/orders';
import './shoppingHeader.scss';

interface IShoppingHeader {
  ordersList?: IProductList[];
}

interface IQuantities {
  pending?: number;
  confirm?: number;
  delivery?: number;
  cancel?: number;
}

const ShoppingHeader: FC<IShoppingHeader> = ({ ordersList }: IShoppingHeader) => {
  const [quantities, setQuantities] = useState<IQuantities>({ pending: 0, confirm: 0, delivery: 0, cancel: 0 });
  const [showInfo, setShowInfo] = useState<boolean>(false);

  const lengthOrdersType = () => {
    if (ordersList) {
      const payment = ordersList.filter(element => element.statusName === ORDER_STATUS.PENDING);
      const confirm = ordersList.filter(element => element.statusName === ORDER_STATUS.ACTIVE);
      const deliverySuccess = ordersList.filter(element => element.statusName === ORDER_STATUS.DELIVERED);
      const cancel = ordersList.filter(element => element.statusName === ORDER_STATUS.CANCELLED);

      setQuantities({
        pending: payment?.length || 0,
        confirm: confirm?.length || 0,
        delivery: deliverySuccess?.length || 0,
        cancel: cancel?.length || 0
      });
    }
  };

  useEffect(() => {
    lengthOrdersType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersList]);

  return (
    <div id="shoppingHeader">
      <div className="titleHeader">
        <div className="styleTitle">{`Pendiente de confirmación (${quantities.pending})`} </div>
        <div className="spaceProcess">
          <div className="containerIcon">
            <Arrows />
          </div>
          <div className="spaceTitle">Autom/ Manual</div>
        </div>
      </div>
      <div className="titleHeader">
        <div className="styleTitle">{`Confirmados/ Activos (${quantities.confirm})`}</div>
        <div className="spaceProcess">
          <div className="containerIcon">
            <Arrows />
          </div>
          <div className="spaceTitle">Automatico</div>
        </div>
      </div>
      <div className="titleHeader">
        <div className="styleTitle">
          {`Entregado (${quantities.delivery})`}
          <div
            className="floatInformation"
            onMouseOver={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
          >
            <InformationIcon />
            {showInfo && (
              <div className="floatSpace">
                Las órdenes pasarán a entregado automáticamente una vez que modifiques los envíos en el detalle de la
                orden.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingHeader;
